<template>
<div class="dashboard">
  <div style="width:1140px">

    <div id="aiexamine" class="dashboard-container">

      <div class="dashboard-toplayout">
        <!-- <el-divider class="dashboard-divider" direction="vertical"> </el-divider> -->
        <span class="dashboard-toplayout-ftsbig">著录内容AI审核</span>

      </div>
      <!-- :row-style="rowStyle" -->
      <div style="display:flex;justify-content:center;margin: 50px; color: #4c70e8;align-items:center">
        <i class=" el-icon-loading" style="font-size:50px" />
        <span>著录内容AI审核中...</span>
      </div>
    </div>
    <div class="dashboard-container">

      <div class="dashboard-toplayout">
        <!-- <el-divider class="dashboard-divider" direction="vertical"> </el-divider> -->
        <span class="dashboard-toplayout-ftsbig">温馨提示</span>

      </div>

      <ol class="dashboard-toplayout-ftsnomal">
        <li>
          资源审核中请勿关闭页面，审核完成后将自动进行下一步操作。

        </li>
        <li>AI会对内容进行涉黄涉政涉暴判定，违规内容将被自动删除·不会进入后续流程，申诉请联系客服。</li>
      </ol>

    </div>
    <div id="next" class="dashboard-container" style="padding:0px;margin-bottom:20px">
      <el-button disabled type="primary" style="width:100%;font-size: 14px;color: #FFFFFF;height: 40px;background: #7B84A1;opacity: 0.5;border:0px" size="default" @click="uploadnext">自动执行中，完成后将自动进入下一步</el-button>

    </div>
  </div>
  <div>
    <div class="rowright">

      <div class="rowright-contain" @click="scrollViewId('#aiexamine')">
        <img style="width:36px;height: 36px;" src="@/assets/implement.png" alt="404">
        <span class="rowright-btn">自动执行中</span>

      </div>
    </div>
  </div>

</div>
</template>

<script>
import {
  aiTask,
  textAudit
} from '@/api/library'


export default {

  props: {
    nextStatus: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      fileList: [],
      time: null
    }
  },
  mounted() {

    this.textAudit()
  },
  beforeDestroy() {

    if (this.time != null) {
      clearInterval(this.time)
      this.time = null
    }
  },
  methods: {
    async textAudit() {

      const res = await textAudit({
        ids: this.$route.query.collectionId,
        status: this.nextStatus
      })
      if (res.data) {
        this.timeSend()
      }
    },
    changeData() {
      this.$router.push({
        path: '/single',
        query: {
          collectionId: 0,
          status: 'upload'
        }
      })
      this.uploadnext()
    },
    timeSend() {
      this.time = setInterval(() => {
        this.aiTask()
      }, 10000)
    },
    async aiTask() {
      const res = await aiTask({
        ids: this.$route.query.collectionId,
        type: 'cataloging'
      })
      if (res.data != null) {
        if (res.data.length === 0) {
          if (this.time != null) {
            clearInterval(this.time)
            this.time = null
          }
          return
        }
        this.fileList = res.data[0].aiTaskResourceVOS

        if (res.data[0].status === 2) {
          if (this.time != null) {
            clearInterval(this.time)
            this.time = null
          }
          this.uploadnext()
        }
      }
    },

    uploadnext() {
      this.$emit('uploadNext')
    },
    scrollViewId(name) {
      document.querySelector(name).scrollIntoView(true)
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .is-leaf {
  border-bottom: 1px solid #EBEEF5;
  border-top: 1px solid #EBEEF5;
}

::v-deep .el-table__empty-text {
  line-height: 100px;
  width: 50%;
  color: #7B84A1;
  font-size: 12px;
  opacity: 0.5;
}

::v-deep .el-table::before {
  left: 0;
  bottom: 0;
  width: 100%;
  height: 0px;
}

.el-table {
  ::v-deep tbody tr:hover>td {
    background-color: transparent;
  }

  ::v-deep th {
    padding: 3px 0;
    min-width: 0;
  }

  ::v-deep td {
    border-bottom: 0px;
    color: #1F233E;
    font-size: 12px;
    padding: 3px 0;
    min-width: 0;
  }
}

.rowright {
  display: flex;
  position: fixed;
  top: 200px;
  width: 100px;
  flex-direction: column;

  &-contain {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    height: 70px;
    border-top-right-radius: 6px;
    border-bottom-right-radius: 6px;
    background-color: #b7bccd;
    cursor: pointer;
  }

  &-btn {
    font-size: 12px;
    width: 100px;
    color: #FEFEFE;
    width: auto;

  }

  &-next {

    padding: 0px;
    margin: 0px;
    font-size: 18px;
    font-weight: bold;
    color: #FEFEFE;
  }
}

.row {

  display: flex;
  align-items: center;
  float: right;
  width: 315px;
  overflow: hidden;
  text-align: center;
  margin-right: 0px;

  &-img {
    opacity: 0.5;
  }

  &-img:hover {
    opacity: 1;
  }
}

.dashboard {
  margin: auto;
  padding-top: 51px;
  width: 1240px;
  flex-direction: row;
  display: flex;
  box-sizing: border-box;

  // &-container {
  //   margin-left: 20px;
  //   padding: 30px;
  //   border-radius: 5px;
  //   margin-top: 20px;
  //   background-color: #fff;
  //   box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04)
  // }
  &-container {

    padding: 20px;
    border-radius: 5px;
    margin-top: 20px;
    background-color: #fff;
    box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04)
  }

  &-toplayout {
    display: flex;
    // flex-direction: row-reverse;
    margin: 0px 0px 10px 0px;
    align-items: center;
    justify-content: space-between;
    color: #000;
    font-size: 14px;
    line-height: 25px;

    &-right {
      display: flex;
      align-items: center;
      justify-content: center;
    }

    &-space {
      display: flex;
      align-items: center;
      padding-left: 10px;
      padding-right: 11px;
      justify-content: space-between;
    }

    &-mgright {
      margin-right: 11px;

      font-size: 12px;
      line-height: 24px;
      color: #1F233E;

    }

    &-num {
      width: 24px;
      height: 24px;
      font-size: 12px;
      margin-right: 11px;
      // line-height: 24px;
      color: #ffff;
      display: flex;
      justify-content: center;
      background: #7B84A1;
      border-radius: 5px;
    }

    &-btn {
      margin-right: 15px;
      height: 24px;
      width: 176px;
      background: #7B84A1;
      border-radius: 5px;
      font-size: 12px;
      color: #FFFFFF;
      line-height: 24px;
    }

    &-ftsbig {

      font-size: 20px;
      font-weight: bold;
      color: #4C70E8;

    }

    &-ftsnomal {
      /* margin-left: -25px; */
      font-size: 12px;
      color: #1F233E;
      line-height: 24px;

    }
  }
}
</style>
